export const getIsPlayStation = (userAgent?: string) => {
    return userAgent?.match(/PlayStation/i);
};
